<app-base-modal
  [title]="'Импорт упаковок'"
>
  <app-delayed-file-upload-card
    [allowedExtensions]="excelExtensions"
    [multiple]="false"
    (filesSelectedForUpload)="filesSelectedForUpload($event)"
  />
  <div class="buttons-container">
    <button
      mat-button
      color="primary"
      [disabled]="!selectedFile"
      (click)="handleUploadExcel()"
    >
      Сохранить
    </button>
    <button
      mat-button
      color="warn"
      (click)="closeDialog('cancel')"
    >
      Отменить
    </button>
  </div>
</app-base-modal>
